if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"cia_backoffice_inspiration","remotes":[{"alias":"uidispatcher_api","name":"uidispatcher_api","entry":"/ordercapture/uidispatcher/static/uidispatcherapi.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^3(78|9)5$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}